import { KeyRound, LayoutGrid, Zap, AlertTriangle, BatteryCharging, Snowflake, Wrench, Droplets, Car, Hammer, Leaf, Paintbrush, Circle, Disc, SprayCan, Bug, Lock, Cog, Pill, Stethoscope, HeartHandshake, Baby } from "lucide-react";

const ICONS = {
  key: KeyRound,
  lock: Lock,
  grid: LayoutGrid,
  flash: Zap,
  zap: Zap,
  warning: AlertTriangle,
  "battery-charging": BatteryCharging,
  snow: Snowflake,
  droplets: Droplets,
  water: Droplets,
  car: Car,
  hammer: Hammer,
  leaf: Leaf,
  paintbrush: Paintbrush,
  spray: SprayCan,
  bug: Bug,
  ellipse: Circle,
  disc: Disc,
  wrench: Wrench,
  paint: Paintbrush,
  cog: Cog,
  settings: Cog,
  pill: Pill,
  medical: Stethoscope,
  stethoscope: Stethoscope,
  heart: HeartHandshake,
  "heart-handshake": HeartHandshake,
  baby: Baby,
};

export function CategoryIcon({ icon, className = "w-5 h-5" }) {
  const Icon = ICONS[icon] || Wrench;
  return <Icon className={className} strokeWidth={2} />;
}
